import React from 'react';
import $ from 'jquery';

//elegant form validation
import TextView from '../../elegant_form_validation/Util/TextView.js';
import update from 'immutability-helper';
import { run, ruleRunner } from '../../elegant_form_validation/Validation/ruleRunner.js'
import { required } from '../../elegant_form_validation/Validation/rules.js';

import {
  Redirect
} from 'react-router-dom';

import Row from '../ui/Row';
import RestClient from '../rest/RestClient';
import CommonHelper from '../helpers/CommonHelper';

import * as moment from 'moment';
import Config from '../Config';

import { Link  } from 'react-router-dom'
//BrowserRouter
import Cell from '../ui/Cell';
import Container from 'react-bootstrap/esm/Container.js';


const fieldValidations = [
  ruleRunner("emailAddress", "Email Address", required),
  ruleRunner("password1", "Password", required),
];

const apiUrl = Config.apiURL;



export default class Entrance extends React.Component {
  Mode = {
    ENTRANCE              : 1,
    LOGIN_UI              : 2,
    LOGIN_DO              : 3,
    LOGIN_FAILED          : 4,

    AUTHORIZE_1ST_ACCOUNT : 6,
    AUTHORIZED            : 5
  };

  static key_refid_periodicTokenExpirationCheck = 'refid_periodicTokenExpirationCheck';

  constructor(props) {
    super(props);

    this.state = {
      grant_type            : false,
      mode                  : this.Mode.ENTRANCE,
      showErrors            : false,
      validationErrors      : { },
      remoteError           : '',
      redirectToLinkAccount : false,
      redirectToReAuthAccount : false,
      //    redraw            : 0
    }

    localStorage.removeItem(Entrance.key_refid_periodicTokenExpirationCheck);
    var it = localStorage.getItem(Entrance.key_refid_periodicTokenExpirationCheck);
  }

  static silentEnter(enforceRefresh=false) {

    var queryData = {};

    var refresh = false;
    if(Entrance.tokenIsCloseToExpiration() || enforceRefresh){
      refresh = true;
      queryData = {
        'grant_type'  : 'refresh',
        'refresh_token' : Entrance.refreshToken()
      };
    }else {
      queryData = {'grant_type': 'entrance'};
    }


    RestClient.enter(
      queryData,
      (data)=>{
        Entrance.updateAll_withSuccessData(data);
        Entrance.silent_completeSuccessOfEntrance(data);
      },
      ()=>{}
    );

  }

  static tokenIsCloseToExpiration(){

    return (moment().unix() >= (Entrance.tokenExpiresAt() - 60));
  }

  static isAuthenticated() {
    return (Entrance.hasAccessToken() && !Entrance.isRefreshTokenExpired());
  }

  static isRecentLoginQueryFailed() {
    return localStorage.getItem('recentLoginQuery_failed');
  }

  static decodedAccessToken() {
    var jwtDecode = require('jwt-decode');
    var access_token = localStorage.getItem('access_token');

    if (CommonHelper.isNotEmpty(access_token)){
      return jwtDecode(access_token);
    } else {
      return null;
    }
  }

  static isTokenExpired(){
    return (moment().unix() > Entrance.tokenExpiresAt());
  }

  static isRefreshTokenExpired(){
    return (moment().unix() > Entrance.refreshTokenExpiresAt());
  }

  componentWillMount() {
    document.body.classList.add('entrance-page');

    this.setState({activityOn: false});
    this.setState({validationErrors: run(this.state, fieldValidations)});

    if(!Entrance.hasAccessToken() || (Entrance.isTokenExpired() && Entrance.isRefreshTokenExpired())){
      this.setState({ mode: this.Mode.LOGIN_UI });
    }else{
      //entrance
      //for now we do always entrance
      this.setState({ mode: this.Mode.ENTRANCE });
      localStorage.setItem('is_authorized', 0);

      var queryData = {};
      var refresh = false;
      if(Entrance.tokenIsCloseToExpiration()){
        refresh= true;
        queryData = {
          'grant_type'  : 'refresh',
          'refresh_token' : Entrance.refreshToken()
        };
      }else {
        queryData = {'grant_type': 'entrance'};
      }

      RestClient.enter(
        queryData,
        (data)=>{
          Entrance.updateAll_withSuccessData(data);
          this.completeSuccessOfEntrance(data);

        },
        ()=>{
          this.setState({ mode: this.Mode.LOGIN_FAILED });
        }
      );

    }
  }

  componentWillUnmount(){
    document.body.classList.remove('entrance-page'); 
  }

  componentDidMount() {
    $(document).ready(function() {
      $('form').bind('submit', $('form'), function(event) {

          var form = this;

          event.preventDefault();
          event.stopPropagation();

          if (form.submitted) {
              return;
          }

          form.submitted = true;
      });
    });


  }

  static hasAccessToken() {
    var access_token = localStorage.getItem('access_token');

    return (!CommonHelper.isNull(access_token) && access_token!=='undefined');
  }

  isAuthorized() {
    return this.isModeIs(this.Mode.AUTHORIZED);
  }

  isRecentLoginQueryFailed() {
    return localStorage.getItem('recentLoginQuery_failed');
  }

  encodedAccessToken() {
    return (localStorage.getItem('access_token'));
  }

  decodedAccessToken() {
    var jwtDecode = require('jwt-decode');
    return jwtDecode(localStorage.getItem('access_token'));
  }

  static accountId() {
    return Entrance.decodedAccessToken()['account_id'];
  }

  static purchaseEndTime() {
    return Entrance.decodedAccessToken()['purchase_endtime'];
  }

  static purchaseTimeLeft() {
    var t = Entrance.purchaseEndTime() - moment().unix();
    if (t<0) { t=0; }
    return t;
  }

  static jwtMark(){
    return localStorage.getItem('jwt_mark');
  }

  static loginOfCurrentAccount() {
    return Entrance.decodedAccessToken()['login'];
  }

  static role() {
    return Entrance.decodedAccessToken()['role'];
  }

  static accessToken() {
    return localStorage.getItem('access_token');
  }

  static refreshToken() {
    return localStorage.getItem('refresh_token');
  }

  static tokenExpiresAt() {
    //return localStorage.getItem('expires_at');
    return Entrance.decodedAccessToken()['exp'];
  }

  static refreshTokenExpiresAt() {
    return localStorage.getItem('refresh_expires_at');
  }

  static accountsMissingAtLastLogin() {
    return CommonHelper.isNull(Entrance.accountId());
  }

  static switchAccount(account_id, cbSuccess, cbFailure) {
    var jwtDecode = require('jwt-decode');
    RestClient.switchAccount(account_id,
    (data)=>{
      Entrance.updateAll_withSuccessData(data);
      Entrance.silent_completeSuccessOfEntrance(data);

      setTimeout(cbSuccess, 1);
    },
    ()=>{
      setTimeout(cbFailure, 1);
    });
  }

  static signout(cb) {
    //this.isAuthenticated = false;
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('expires_at');
    setTimeout(cb, 100)
  }

  //from login
  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  handleFieldChanged(field) {
    return (e) => {
      // update() is provided by React Immutability Helpers
      // https://facebook.github.io/react/docs/update.html
      let newState = update(this.state, {
        [field]: {$set: e.target.value}
      });
      newState.validationErrors = run(newState, fieldValidations);
      this.setState(newState);
    };
  }

  static reAuthSignalDetected(){
      var decodedToken = Entrance.decodedAccessToken();
      return  (CommonHelper.isNotEmpty(decodedToken) && decodedToken['to_auth_on_sc_for_cur_acc'] === 1);
  }

  completeSuccessOfLogin(data) {
    this.isAuthenticated = true;

    localStorage.setItem('is_authorized', 201);
    this.setState({ mode: this.Mode.AUTHORIZED });

    //the render func will decide which state use

    if (Entrance.accountsMissingAtLastLogin()){
      this.setState({ redirectToLinkAccount: true });
    }else if (Entrance.reAuthSignalDetected()){
      this.setState({ redirectToReAuthAccount: true });
    }else {
      this.setState({ redirectToReferrer: true });
    }

    Entrance.startPeriodicTokenExpirationCheck();
  }




  static silent_completeSuccessOfEntrance(data){
    localStorage.setItem('is_authorized', 201);
  }



  completeSuccessOfEntrance(data) {
    Entrance.silent_completeSuccessOfEntrance(data);
    this.setState({ mode: this.Mode.AUTHORIZED });

     if (Entrance.reAuthSignalDetected()){
       this.setState({ redirectToReAuthAccount: true });
     }else{
       this.setState({ redirectToReferrer: true });
     }

    Entrance.startPeriodicTokenExpirationCheck();
  }

  login = () => {
    this.setState({showErrors: true});
    if($.isEmptyObject(this.state.validationErrors) === false) return null;

    this.setState({ mode: this.Mode.LOGIN_DO });

    var jwtDecode = require('jwt-decode');

    RestClient.enter(
      {
        'grant_type': 'login',
        'login': this.state.emailAddress.trim(),
        'password': this.state.password1.trim(),
        'tz': Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      (data)=>{//OK

        document.getElementById('hidden_username').value = this.state.emailAddress;
        document.getElementById('hidden_password').value = this.state.password1;
        var hiddenForm = document.getElementById('loginform');
        hiddenForm.submitted = true;
        hiddenForm.submit();

        Entrance.updateAll_withSuccessData(data);

        this.completeSuccessOfLogin(data);
      },

      (schError)=>{//FAILURE
        this.setState({ remoteError: schError.getFormattedMessage() });
        this.setState({ mode: this.Mode.LOGIN_FAILED });
      }
    );
  }

  isModeIs(mode) {
    return (this.state.mode == mode);
  }


  static startPeriodicTokenExpirationCheck(){
    var strKey = Entrance.key_refid_periodicTokenExpirationCheck;
    var refId =  JSON.parse(localStorage.getItem(strKey));

    if(CommonHelper.isNull(refId)){
      var refId = setInterval(Entrance.periodicTokenExpirationCheck, Config.tokenExpirationCheckPeriod*1000);
      localStorage.setItem(strKey, refId);
    } else {
    }
  }

  static periodicTokenExpirationCheck(){
    if(Entrance.isAuthenticated() && Entrance.tokenIsCloseToExpiration()){
      Entrance.silentEnter();
    } else {
    }

  }

  static updateAll_withSuccessData(data){
    var key = 'access_token';
    var val = data['token'];

    if (!CommonHelper.isNull(val)) {localStorage.setItem(key, val);}

    key = 'refresh_token';
    val = data['refresh_token'];

    if (!CommonHelper.isNull(val)) {localStorage.setItem(key, val);}

    key = 'refresh_expires_at';
    val = data['refresh_expires_at'];
    if (!CommonHelper.isNull(val)) {localStorage.setItem(key, val);}

    key = 'jwt_mark';
    val = data['jwt_mark'];
    if (!CommonHelper.isNull(val)) {localStorage.setItem(key, val);}
  }



  render() {
    var Mode = this.Mode;
    const { from } = this.props.location.state || { from: { pathname: Config.dirHostedAt +'/main' } };

    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return (
       <Redirect to={from}/>
      )
    }

    const { redirectToLinkAccount } = this.state;
    if (redirectToLinkAccount) {
      var base = CommonHelper.removeLastDirectoryPartOf(this.props.location.pathname);
      var redirTo = base + "/link_account";
      return (
       <Redirect to={redirTo}/>
      )
    }

    const { redirectToReAuthAccount } = this.state;
    if (redirectToReAuthAccount) {
      var base = CommonHelper.removeLastDirectoryPartOf(this.props.location.pathname);
      var redirTo = base + "/reauth_account";

      return (<Redirect to={{pathname: Config.dirHostedAt+'/reauth_account', state: { from: this.props.location }}}/>);

    }

    switch(this.state.mode)
    {
      case Mode.ENTRANCE:
        return(
          <div className="login-page">
            <Container align="center">
              <Row>
                <Cell>
                    <p>Initializing...</p>
                </Cell>
              </Row>
            </Container>
          </div>
        );

      case Mode.AUTHORIZED:
        return(
          <div className="login-page">
            <Container align="center">
              <Row>
                <Cell>
                    <p>Success!</p>
                </Cell>
              </Row>
            </Container>
          </div>
        );

      case Mode.LOGIN_UI:
      case Mode.LOGIN_DO:
      //
      case Mode.LOGIN_FAILED:
        return (
          <div className="login-page">
            <Container align="center">
              <Row>
                <h6 class="mb-4">{((from.pathname!=='/')?('You must log in to view the page at ' + from.pathname) + '. ':'')}</h6>
              </Row>

              <Row>
                <div class={(this.isModeIs(Mode.LOGIN_DO))?"waiting":""}>{(this.isModeIs(Mode.LOGIN_DO))?"Authenticating":""}</div>
                <p class="text-red">{(this.isModeIs(Mode.LOGIN_FAILED))?this.state.remoteError:''}</p>
              </Row>

              <form autoComplete="on">
                <Row>
                  <TextView id="sch_login" name="z_sch_login" placeholder="Email Address" showError={this.state.showErrors}
                        text={this.props.emailAddress} onFieldChanged={this.handleFieldChanged("emailAddress")}
                      verticalWithError="true"
                        errorText={this.errorFor("emailAddress")} />
                </Row>

                <Row>
                  <TextView
                      id="sch_password"
                      placeholder="Password"
                      showError={this.state.showErrors}
                      type="password"
                      text={this.props.password1}
                      onKeyPress={(ev) => {
                        if (ev.key === 'Enter') {
                                // Do code here
                                this.login();
                                ev.preventDefault();
                            }
                    }}
                    onFieldChanged={this.handleFieldChanged("password1")}
                    verticalWithError="true"
                    errorText={this.errorFor("password1")}
                    />

                </Row>
              </form>

              <Row>
                <button  type='submit' id="green" className="sc-btn sc-btn-red sc-btn-big" onClick={this.login}><span>Login</span></button>
              </Row>

              <iframe name="aim" style={{display:'none'}}></iframe>

              <form id="loginform" action="fsdf" method="post" target="aim" style={{display:'none'}}>
                <input id="hidden_username" name="username" type="text" value=""  />
                <input id="hidden_password" name="password" type="password" value="" />
                <input type="submit" name="doLogin" value="Login" />
              </form>

              <Cell>
                <Link id='forgot_pass' className="d-none"  to={Config.dirHostedAt+'/forgot_pass/'}>Forgot password?</Link>
                  <button type='submit' class="sc-btn-forgot-pass btn btn-link" onClick={()=>{document.getElementById('forgot_pass').click();}}>Forgot password?</button>
              </Cell>
            </Container>   
          </div>
        );

      case Mode.AUTHORIZE_1ST_ACCOUNT:
        return (
        <div className="login-page">
          <Container align="center">
            <Row>
              <h6>{((from.pathname!=='/')?('You must log in to view the page at ' + from.pathname):'')}</h6>
            </Row>
            <Row>
              <div class={(this.isModeIs(Mode.LOGIN_DO))?"waiting":""}>{(this.isModeIs(Mode.LOGIN_DO))?"Authenticating":""}</div>
              <p style={{color:'red'}}>{(this.isModeIs(Mode.LOGIN_FAILED))?this.state.remoteError:''}</p>
            </Row>
            <Row>
              <TextView placeholder="Email Address" showError={this.state.showErrors}
                    text={this.props.emailAddress} onFieldChanged={this.handleFieldChanged("emailAddress")}
                  verticalWithError="true"
                    errorText={this.errorFor("emailAddress")} />
            </Row>
            <Row>
              <TextView
                  placeholder="Password"
                  showError={this.state.showErrors}
                  type="password"
                  text={this.props.password1}
                  onKeyPress={(ev) => {
                    if (ev.key === 'Enter') {
                          // Do code here
                          this.login();
                          ev.preventDefault();
                      }
                    }}
                  onFieldChanged={this.handleFieldChanged("password1")}
                  verticalWithError="true"
                  errorText={this.errorFor("password1")}
                  onKeyDown={this._handleKeyDownInPassword}
                    />
            </Row>
            <Row>
              <button  type='submit' id="green" class="sc-btn-forgot-pass btn btn-link" onClick={this.login}><span>Login</span></button>
            </Row>
          </Container>  
        </div>
        );

      default: return (<div>.</div>); break;
    }
  }
}
